import { Component } from '@angular/core';

@Component({
  selector: 'app-asset-qr-approval-link',
  templateUrl: './asset-qr-approval-link.component.html',
  styleUrls: ['./asset-qr-approval-link.component.scss']
})
export class AssetQrApprovalLinkComponent {

}
